import { sharedReducerFn } from "./shared-reducer";

export function sharedReducer(state, action) {
    return sharedReducerFn(state, action)
    
}

/** Below code is example of how to combine multiple reducers */
// export const sharedStoreReducers: ActionReducerMap<any> = {
//     browserStorage: browserStorageReducer,
//     cartsByLegalEntity: cartsByLegalEntityReducer
// };